import {useContext, createContext} from 'react';
import {IContext} from './Types';

/**
 *
 */
export const Context = createContext({} as IContext);

/**
 *
 * @returns
 */
export function useSalesmanContext(): IContext {
  return useContext(Context);
}

export default useSalesmanContext;
